import {Dispatcher as FluxDispatcher} from 'flux';

let Dispatcher = new FluxDispatcher();

// todo explore: dispatch queue

export default Dispatcher;
